import { supabase } from "../lib/supabase";

// Used only for user sign up since it includes additional metadata. Admin sign up is not allowed through the app, so we don't need a separate service function for it.
export const signUpUser = async (signUpForm) => {
  return supabase.auth.signUp({
    // Core signUp credentials
    email: signUpForm.email,
    password: signUpForm.password,
    // Additional user metadata to store in the auth.users table
    options: {
      data: {
        full_name: signUpForm.fullName,
        occupation: signUpForm.occupation,
        state: signUpForm.state,
        lga: signUpForm.lga,
      },
    },
  });
};

// Used for both user and admin sign in.
export const signInUser = async (signInForm) => {
  return supabase.auth.signInWithPassword({
    email: signInForm.email,
    password: signInForm.password,
  });
};
